import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class WorkflowService {

    baseUrl = environment.API_URL;

    constructor(
        private http:  ApiHttpClient
    ) {
      this.baseUrl = environment.API_URL;
    }

    getCriteriaOptions(option: string): Observable<any> {
        const params = new HttpParams().set('option', option);
        return this.http.get<any>('/automation-sequence/criteria-options', { params });
    }
}
